<template>
  <div class="d-flex flex-column flex-root">
    <div class="d-flex flex-column flex-center flex-column-fluid p-10">
      <div class="text-center">
        <div v-if="loading" class="spinner spinner-primary spinner-lg"></div>
        <h3 v-if="loading" class="mt-5">Autenticando...</h3>
        <h3 v-if="erro" class="text-danger">{{ erro }}</h3>
        <p v-if="erro">
          <a :href="loginUrl" class="btn btn-primary mt-5">Voltar ao login</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import JwtService from "@/core/services/jwt.service";

export default {
  name: "SSOCallback",
  data() {
    return {
      loading: true,
      erro: null
    };
  },
  computed: {
    loginUrl() {
      return process.env.BASE_URL + "login";
    }
  },
  mounted() {
    const token = this.$route.query.token;

    if (!token) {
      this.erro = "Token de autenticação não recebido.";
      this.loading = false;
      return;
    }

    JwtService.saveToken(token);

    // Usa reload completo (nao router.push) para que o Vuex reinicialize
    // isAuthenticated a partir do token recem-salvo e o guard de rota
    // dispare verificar-login na primeira navegacao (from.name indefinido).
    window.location.href = "/";
  }
};
</script>
